export default __webpack_public_path__ + "static/media/logoutBannerMobile.7e325d4b.png";